var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInProgress1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_5933_13523_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0325 0 0 0.0325 40.5 39.5)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1020,
    y: -1020,
    width: 2040,
    height: 2040
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(108, 227, 196, 1) 0deg,rgba(255, 255, 255, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 7C58.4493 7 73 21.5507 73 39.5C73 57.4493 58.4493 72 40.5 72C22.5507 72 8 57.4493 8 39.5C8 21.5507 22.5507 7 40.5 7ZM40.5 67.125C55.7569 67.125 68.125 54.7569 68.125 39.5C68.125 24.2431 55.7569 11.875 40.5 11.875C25.2431 11.875 12.875 24.2431 12.875 39.5C12.875 54.7569 25.2431 67.125 40.5 67.125Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.42352941632270813,\"g\":0.89019608497619629,\"b\":0.76862746477127075,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.42352941632270813,\"g\":0.89019608497619629,\"b\":0.76862746477127075,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":65.0,\"m01\":-7.0700861784262371e-15,\"m02\":8.0,\"m10\":7.0700861784262371e-15,\"m11\":65.0,\"m12\":7.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_5933_13523_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5 7C58.4493 7 73 21.5507 73 39.5C73 57.4493 58.4493 72 40.5 72C22.5507 72 8 57.4493 8 39.5C8 21.5507 22.5507 7 40.5 7ZM40.5 67.125C55.7569 67.125 68.125 54.7569 68.125 39.5C68.125 24.2431 55.7569 11.875 40.5 11.875C25.2431 11.875 12.875 24.2431 12.875 39.5C12.875 54.7569 25.2431 67.125 40.5 67.125Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress1);
export default __webpack_public_path__ + "static/media/InProgress1.918778a4fbb1d00a92e50a7ab0e7d528.svg";
export { ForwardRef as ReactComponent };